import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { MdClose } from 'react-icons/md';
import styled from 'styled-components';
import { defineMessages, useIntl, FormattedMessage } from '@techstyle/react-intl';
import Button from '../Button';
import { OptionLabelProvider, FilterFieldLabelProvider, CategoryLabelProvider } from '../LabelProvider';
import { LabelType } from '../LabelProvider/constants';
import { useProductFilters } from '../ProductFilterContextCustomFilters';
import { mobile } from '../styles';
var messages = defineMessages({
  deselectLabel: {
    id: 'site_product_filter.deselect_button',
    defaultMessage: 'Dismiss {filterValue} filter'
  }
});
var TagHeader = styled.div.withConfig({
  displayName: "FilterTagsCustomFilters__TagHeader",
  componentId: "sc-j4b5rf-0"
})(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  font-size: 14px;\n  line-height: 32px;\n  color: #333;\n\n  ", "\n"], mobile(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: 16px;\n    line-height: 48px;\n  "]))));
var HeaderLabelWrapper = styled.span.withConfig({
  displayName: "FilterTagsCustomFilters__HeaderLabelWrapper",
  componentId: "sc-j4b5rf-1"
})(["\n  ", ";\n"], _ref => {
  var headerStyle = _ref.headerStyle;
  return headerStyle;
});
var ClearAllButton = styled(Button).attrs(() => ({
  variant: 'clearAllFilters'
})).withConfig({
  displayName: "FilterTagsCustomFilters__ClearAllButton",
  componentId: "sc-j4b5rf-2"
})(["\n  appearance: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n\n  &,\n  &:focus,\n  &:hover {\n    text-decoration: underline;\n  }\n\n  ", ";\n"], _ref2 => {
  var buttonStyle = _ref2.buttonStyle;
  return buttonStyle;
});
var TagList = styled.ul.withConfig({
  displayName: "FilterTagsCustomFilters__TagList",
  componentId: "sc-j4b5rf-3"
})(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  list-style-type: none;\n  margin: -4px 0 0 0;\n\n  ", ";\n"], _ref3 => {
  var tagListStyle = _ref3.tagListStyle;
  return tagListStyle;
});
var Tag = styled.li.withConfig({
  displayName: "FilterTagsCustomFilters__Tag",
  componentId: "sc-j4b5rf-4"
})(["\n  padding: 0 0 0 8px;\n  margin: 4px 4px 0 0;\n  background: #eeeeee;\n  border-radius: 4px;\n  text-align: left;\n  font-size: 12px;\n  line-height: 24px;\n  color: #333;\n\n  ", "\n\n  ", ";\n"], mobile(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 14px;\n    line-height: 32px;\n  "]))), _ref4 => {
  var tagStyle = _ref4.tagStyle;
  return tagStyle;
});
var DeselectIcon = styled(MdClose).withConfig({
  displayName: "FilterTagsCustomFilters__DeselectIcon",
  componentId: "sc-j4b5rf-5"
})(["\n  display: inline-block;\n  vertical-align: -2px;\n  color: #999;\n"]);
var DeselectButton = styled(Button).attrs(() => ({
  variant: 'deselectFilter'
})).withConfig({
  displayName: "FilterTagsCustomFilters__DeselectButton",
  componentId: "sc-j4b5rf-6"
})(["\n  width: auto;\n  height: 24px;\n  appearance: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0 6px 0 3px;\n  margin-left: 2px;\n  font-size: 12px;\n\n  ", ";\n\n  ", ";\n"], mobile(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    height: 32px;\n    font-size: 16px;\n  "]))), _ref5 => {
  var buttonStyle = _ref5.buttonStyle;
  return buttonStyle;
});

var FilterTags = _ref6 => {
  var clearAllButtonComponent = _ref6.clearAllButtonComponent,
      clearAllButtonStyle = _ref6.clearAllButtonStyle,
      deselectButtonStyle = _ref6.deselectButtonStyle,
      children = _ref6.children,
      headerStyle = _ref6.headerStyle,
      onClearAll = _ref6.onClearAll,
      tagListStyle = _ref6.tagListStyle,
      tagStyle = _ref6.tagStyle,
      headerLabelComponent = _ref6.headerLabelComponent,
      hideClearAllButton = _ref6.hideClearAllButton,
      rest = _objectWithoutProperties(_ref6, ["clearAllButtonComponent", "clearAllButtonStyle", "deselectButtonStyle", "children", "headerStyle", "onClearAll", "tagListStyle", "tagStyle", "headerLabelComponent", "hideClearAllButton"]);

  var ClearAllBtn = clearAllButtonComponent || ClearAllButton;
  return /*#__PURE__*/React.createElement("div", rest, /*#__PURE__*/React.createElement(TagHeader, null, /*#__PURE__*/React.createElement(HeaderLabelWrapper, {
    headerStyle: headerStyle
  }, headerLabelComponent || /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "site_product_filter.filtered_by",
    defaultMessage: "Filtered by:"
  })), !hideClearAllButton && /*#__PURE__*/React.createElement(ClearAllBtn, {
    onClick: onClearAll,
    "data-autotag": "filter-clear-all",
    buttonStyle: clearAllButtonStyle
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "site_product_filter.clear_all",
    defaultMessage: "Clear all"
  }))), /*#__PURE__*/React.createElement(TagList, {
    "data-autotag": "filtered-by-textbox",
    tagListStyle: tagListStyle
  }, children));
};

export var CategoryFilterTags = _ref7 => {
  var categoryFilter = _ref7.categoryFilter,
      selectedFilters = _ref7.selectedFilters,
      rest = _objectWithoutProperties(_ref7, ["categoryFilter", "selectedFilters"]);

  var categoryLabelCtx = CategoryLabelProvider.useLabels();

  var _useProductFilters = useProductFilters(),
      setSelectedFilters = _useProductFilters.setSelectedFilters;

  var categoriesToRender = categoryFilter.items.filter(item => selectedFilters.categoryIds.includes(item.value));
  var labelOptions = {
    labelType: LabelType.CATEGORY_FILTER_TAG
  };
  return categoriesToRender.map(category => {
    return /*#__PURE__*/React.createElement(FilterTag, _extends({
      key: category.value,
      label: categoryLabelCtx.renderLabel(category, labelOptions),
      labelString: categoryLabelCtx.renderLabelString(category, labelOptions),
      onDismiss: () => {
        setSelectedFilters(prevFilters => _objectSpread(_objectSpread({}, prevFilters), {}, {
          categoryIds: prevFilters.categoryIds.filter(value => value !== category.value)
        }));
      },
      value: category
    }, rest));
  });
};
CategoryFilterTags.propTypes = {
  categoryFilter: PropTypes.object,
  selectedFilters: PropTypes.object
};
export var AggregationFilterTags = _ref8 => {
  var filterSetting = _ref8.filterSetting,
      selectedFilters = _ref8.selectedFilters,
      props = _objectWithoutProperties(_ref8, ["filterSetting", "selectedFilters"]);

  var values = selectedFilters.aggregationFilter[filterSetting.field];
  var labelOptions = {
    labelType: LabelType.PRODUCT_FILTER_TAG
  };
  var optionLabelCtx = OptionLabelProvider.useLabels();
  var filterFieldCtx = FilterFieldLabelProvider.useLabels();
  var isSizeFilter = /^size_/.test(filterSetting.field);

  var _useProductFilters2 = useProductFilters(),
      setSelectedFilters = _useProductFilters2.setSelectedFilters;

  var getCurrentItem = value => {
    var _filterSetting$items;

    return (_filterSetting$items = filterSetting.items) === null || _filterSetting$items === void 0 ? void 0 : _filterSetting$items.find(item => item.value === value);
  };

  return values.map(value => {
    var currentItem = getCurrentItem(value);
    var option = {
      label: currentItem !== null && currentItem !== void 0 && currentItem.showLabelAsTag ? currentItem.label : value,
      value: value
    };
    return /*#__PURE__*/React.createElement(FilterTag, _extends({
      key: value,
      label: /*#__PURE__*/React.createElement(React.Fragment, null, optionLabelCtx.renderLabel(filterSetting, option, labelOptions), isSizeFilter ? /*#__PURE__*/React.createElement(React.Fragment, null, ' (', filterFieldCtx.renderLabel(filterSetting, labelOptions), ")") : null),
      labelString: "".concat(optionLabelCtx.renderLabelString(filterSetting, option, labelOptions)).concat(isSizeFilter ? " (".concat(filterFieldCtx.renderLabelString(filterSetting, labelOptions), ")") : ''),
      onDismiss: value => {
        if (currentItem !== null && currentItem !== void 0 && currentItem.removeFilterCallback) {
          currentItem.removeFilterCallback();
        }

        setSelectedFilters(prevFilters => _objectSpread(_objectSpread({}, prevFilters), {}, {
          aggregationFilter: _objectSpread(_objectSpread({}, prevFilters.aggregationFilter), {}, {
            [filterSetting.field]: prevFilters.aggregationFilter[filterSetting.field].filter(prevValue => prevValue !== value)
          })
        }));
      },
      value: value
    }, props));
  });
};
AggregationFilterTags.propTypes = {
  filterSetting: PropTypes.object,
  value: PropTypes.string
};
export var FilterTag = _ref9 => {
  var _ref9$children = _ref9.children,
      children = _ref9$children === void 0 ? /*#__PURE__*/React.createElement(DeselectIcon, null) : _ref9$children,
      deselectButtonStyle = _ref9.deselectButtonStyle,
      label = _ref9.label,
      labelString = _ref9.labelString,
      onDismiss = _ref9.onDismiss,
      tagStyle = _ref9.tagStyle,
      value = _ref9.value;
  var intl = useIntl();
  var deselectLabel = intl.formatMessage(messages.deselectLabel, {
    filterValue: labelString
  });
  var handleDismiss = useCallback(() => {
    onDismiss(value);
  }, [onDismiss, value]);
  return /*#__PURE__*/React.createElement(Tag, {
    "data-autotag": "filtered-by-option",
    tagStyle: tagStyle
  }, label, /*#__PURE__*/React.createElement(DeselectButton, {
    "aria-label": deselectLabel,
    "data-autotag": "filtered-by-option-close-icon",
    buttonStyle: deselectButtonStyle,
    onClick: handleDismiss
  }, children));
};
FilterTag.propTypes = {
  children: PropTypes.any,

  /**
   * See: ../ProductListingFilter/__fixtures__/filterData.json
   * This consists of information for both the category's label
   * and key, and the filter's value and label. The labels are
   * necessary to display the filter and to generate slugified
   * internationalization keys.
   */
  deselectButtonStyle: PropTypes.any,
  label: PropTypes.node,
  labelString: PropTypes.string,
  onDismiss: PropTypes.func,
  tagStyle: PropTypes.any,
  value: PropTypes.any
};
FilterTags.propTypes = {
  children: PropTypes.node,
  clearAllButtonComponent: PropTypes.elementType,
  clearAllButtonStyle: PropTypes.any,
  deselectButtonStyle: PropTypes.any,
  headerLabelComponent: PropTypes.any,
  headerStyle: PropTypes.any,
  hideClearAllButton: PropTypes.bool,
  onClearAll: PropTypes.func,
  tagListStyle: PropTypes.any,
  tagStyle: PropTypes.any
};
FilterTags.AggregationFilterTags = AggregationFilterTags;
FilterTags.CategoryFilterTags = CategoryFilterTags;
FilterTags.FilterTag = FilterTag;
export default FilterTags;